const campaignAllPermission = 'campaign.all';
const contactAllPermission = 'contact.all';
const eventAllPermission = 'event.all';
const formAllPermission = 'form.all';
const importAllPermission = 'import.all';
const importContactPermission = 'import.contact';
const importUserPermission = 'import.user';
const noteAllPermission = 'note.all';
const packageAllPermission = 'package.all';
const roleAllPermission = 'role.all';
const ticketAllPermission = 'ticket.all';
const userAllPermission = 'user.all';
const labelAllPermission = 'label.all';
const opportunityAllPermission = 'opportunity.all';
const whatsappAllPermission = 'whatsapp.all';

export {
    userAllPermission,
    contactAllPermission,
    ticketAllPermission,
    eventAllPermission,
    roleAllPermission,
    noteAllPermission,
    campaignAllPermission,
    packageAllPermission,
    importAllPermission,
    importContactPermission,
    importUserPermission,
    formAllPermission,
    labelAllPermission,
    opportunityAllPermission,
    whatsappAllPermission
};